// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Tabs ──────────────────────────────────────────────────────── */
.tab {
  padding: 10px 20px;
  border: none;
  background: transparent;
  color: #fdfdfd;
  cursor: pointer;
  font-weight: normal;
  border-bottom: 3px solid transparent;
}

.tab.active {
  background: #ffffff;
  color: #00928F;
  font-weight: bold;
  border-bottom: 3px solid #ffffff;
}

.tab:hover {
  color: #000;
  background: rgba(255, 255, 255, 0.1);
}

/* ── Formulario ────────────────────────────────────────────────── */
.form-container {
  background: white;
  border-radius: 12px;
  padding: 40px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.fill_form {
  display: 'grid';
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  background: white;
  padding: 1.25rem;
  border-radius: 8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.form-input {
  width: 100%;
  padding: 10px;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
  box-sizing: border-box;
}

/* ── Botones ───────────────────────────────────────────────────── */
.btn-primary {
  padding: 10px 20px;
  background: #85f5ae;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
  font-size: 14px;
}

.btn-primary:disabled {
  background: #a0a0a0;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-secondary {
  padding: 10px 20px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-edit {
  padding: 5px 10px;
  background: #f2d069;
  color: #000;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  font-size: 12px;
}

.btn-delete {
  padding: 5px 10px;
  background: #b72020;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.formButton {
  width: 100%;
  padding: 12px;
  background: #00928F;
  color: white;
  border: none;
  border-Radius: 6px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

/* ── Tabla ─────────────────────────────────────────────────────── */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table th {
  background: #1e6378;
  color: white;
  padding: 12px;
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
}

.table td {
  padding: 12px;
  border-bottom:
    1px solid #ddd;
  vertical-align: middle;
}

/* ── Modal ─────────────────────────────────────────────────────── */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 350px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

/* ── Navbar ────────────────────────────────────────────────────── */
.navbar {
  background: #00928F;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.navbar-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
}

.navbar-logo {
  height: 52px;
  object-fit: contain;
}

.navbar-fecha {
  color: white;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 18 px;
  opacity: 0.9;
  text-transform: capitalize;
}

.navbar-secciones {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 16px;
  background: rgba(0, 0, 0, 0.15);
}

/* ── Foto ────────────────────────────────────────────────────── */
.espacio-foto {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 2px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  flex-shrink: 0;
}

/* Sin cursor cuando ya tiene foto */
.espacio-foto.con-foto {
  cursor: default;
  border: 2px solid #ccc;
}

.table td:first-child {
  width: 64px;
  padding: 4px;
  text-align: center;
  vertical-align: middle;
}

/*////////////////////////////////////////////////////Responsividad/////////////////////////////////////////////////*/
/* ── Ajustes generales para el Navbar en Desktop ──────────────── */
.navbar-hamburger {
  display: none;
}

.navbar-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.btn-firma {
  background: #ffc107;
  color: #000;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
}

.navbar-role {
  color: white;
  font-size: 14px;
}

/* ── Medias Queries ───────────────────────────────────────────── */

/* ─────────────────────────────────────────────────────────────── */
/* ── Media Queries Unificadas y Optimizadas ──────────────────── */
/* ─────────────────────────────────────────────────────────────── */

@media (max-width: 768px) {

  /* --- Navbar y Menú Hamburguesa --- */
  .navbar-top {
    padding: 10px 16px;
    position: relative;
  }

  .navbar-logo {
    height: 38px;
  }

  .navbar-fecha {
    font-size: 11px;
  }

  .navbar-hamburger {
    display: block !important;
    background: transparent;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    line-height: 1;
    padding: 4px 8px;
  }

  .navbar-secciones {
    display: none;
    flex-direction: column;
    width: 100%;
    padding: 12px 16px;
    background: #007673;
    gap: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  /* Estado al desplegar el menú */
  .navbar-secciones.open {
    display: flex !important;
  }

  .navbar-links {
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    gap: 4px;
  }

  .tab {
    width: 100%;
    text-align: left;
    padding: 10px 14px;
    border-bottom: none;
    border-left: 4px solid transparent;
    border-radius: 4px;
    font-size: 14px;
  }

  /* Visibilidad de pestaña activa en móvil */
  .tab.active,
  .navbar-secciones .tab.active {
    background: rgba(255, 255, 255, 0.2) !important;
    color: #ffffff !important;
    border-left: 4px solid #ffffff;
    border-bottom: none;
  }

  .navbar-actions {
    width: 100%;
    margin-left: 0;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }

  .navbar-actions .btn-delete {
    width: 100%;
    margin-top: 8px;
    padding: 10px;
    font-size: 13px;
    text-align: center;
  }

  /* --- Dashboard & Gráficas --- */
  div[style*="gridTemplateColumns: '1fr 1fr'"],
  div[style*="grid-template-columns: 1fr 1fr"] {
    grid-template-columns: 1fr !important;
  }

  /* --- Modales --- */
  .modal {
    width: 92vw !important;
    max-width: 92vw !important;
    max-height: 90vh !important;
    overflow-y: auto;
    padding: 16px;
  }

  /* --- Tablas --- */
  .table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    width: 100%;
  }

  .table th,
  .table td {
    padding: 10px 8px;
    font-size: 13px;
  }

  /* Botones dentro de las celdas de la tabla (Editar / Eliminar) */
  .table td .btn-edit,
  .table td .btn-delete,
  .table td .btn-secondary {
    width: auto;
    display: inline-block;
    padding: 6px 12px;
  }

  .table td:last-child {
    white-space: nowrap;
  }

  /* --- Toolbar de Tablas --- */
  .table-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .btn-search,
  .table-search-input {
    width: 100% !important;
  }

  .table-pagination-info {
    margin-left: 0;
    justify-content: space-between;
    width: 100%;
  }

  /* --- Paginación --- */
  .table-pagination {
    flex-wrap: wrap;
    gap: 4px;
    justify-content: center;
  }

  .btn-pag {
    flex: 0 0 auto;
    padding: 6px 10px !important;
  }

  /* --- Vista de Usuarios & Acciones de Secciones --- */
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .section-actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 0.5rem;
  }

  .btn-action {
    width: 100% !important;
    text-align: center;
    padding: 8px 6px !important;
    font-size: 12px !important;
  }

  .upload-container,
  .btn-upload {
    width: 100% !important;
    text-align: center;
  }
}

@media (max-width: 480px) {

  /* --- Ajuste de cabecera superior en pantallas pequeñas --- */
  .navbar-top {
    flex-wrap: wrap;
    gap: 8px;
  }

  .navbar-logo {
    order: 1;
  }

  .navbar-hamburger {
    order: 2;
  }

  .navbar-fecha {
    display: block;
    width: 100%;
    order: 3;
    font-size: 11px;
    opacity: 0.85;
  }
}

@media (max-width: 768px) {

  /* Oculta columnas en móvil */
  .table th:nth-child(3),
  /* Usuario */
  .table td:nth-child(3),
  .table th:nth-child(4),
  /* Puesto */
  .table td:nth-child(4),
  .table th:nth-child(6),
  /* Sucursal */
  .table td:nth-child(6) {
    display: none;
  }

  /* Foto más pequeña */
  .espacio-foto {
    width: 40px !important;
    height: 40px !important;
  }

  .table td:last-child {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 60px;
  }

  .btn-edit,
  .btn-delete,
  .btn-secondary {
    width: 100%;
    text-align: center;
  }
  .acciones-celda {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 90px;
  }
  .acciones-celda button {
    width: 100%;
    font-size: 11px;
    padding: 5px 6px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA,qEAAqE;AACrE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;kBACgB;EAChB,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,qEAAqE;AACrE;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6EAA6E;EAC7E,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;AACjC;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qHAAqH;AACrH,oEAAoE;AACpE;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,oEAAoE;;AAEpE,oEAAoE;AACpE,mEAAmE;AACnE,oEAAoE;;AAEpE;;EAEE,sCAAsC;EACtC;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,8CAA8C;EAChD;;EAEA,gCAAgC;EAChC;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;EACjB;;EAEA,2CAA2C;EAC3C;;IAEE,+CAA+C;IAC/C,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;;IAEE,qCAAqC;EACvC;;EAEA,oBAAoB;EACpB;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;EACf;;EAEA,mBAAmB;EACnB;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;EACb;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,iEAAiE;EACjE;;;IAGE,WAAW;IACX,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,8BAA8B;IAC9B,WAAW;EACb;;EAEA,uBAAuB;EACvB;IACE,eAAe;IACf,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA,sDAAsD;EACtD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,2DAA2D;IAC3D,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;;EAEE,8DAA8D;EAC9D;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,QAAQ;IACR,eAAe;IACf,aAAa;EACf;AACF;;AAEA;;EAEE,6BAA6B;EAC7B;;;;;;;;;IASE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Tabs ──────────────────────────────────────────────────────── */\n.tab {\n  padding: 10px 20px;\n  border: none;\n  background: transparent;\n  color: #fdfdfd;\n  cursor: pointer;\n  font-weight: normal;\n  border-bottom: 3px solid transparent;\n}\n\n.tab.active {\n  background: #ffffff;\n  color: #00928F;\n  font-weight: bold;\n  border-bottom: 3px solid #ffffff;\n}\n\n.tab:hover {\n  color: #000;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* ── Formulario ────────────────────────────────────────────────── */\n.form-container {\n  background: white;\n  border-radius: 12px;\n  padding: 40px;\n  width: 100%;\n  max-width: 380px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.fill_form {\n  display: 'grid';\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n  background: white;\n  padding: 1.25rem;\n  border-radius: 8;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.form-input {\n  width: 100%;\n  padding: 10px;\n  margin: 5px 0;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n/* ── Botones ───────────────────────────────────────────────────── */\n.btn-primary {\n  padding: 10px 20px;\n  background: #85f5ae;\n  color: black;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.btn-primary:disabled {\n  background: #a0a0a0;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.btn-secondary {\n  padding: 10px 20px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn-edit {\n  padding: 5px 10px;\n  background: #f2d069;\n  color: #000;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 5px;\n  font-size: 12px;\n}\n\n.btn-delete {\n  padding: 5px 10px;\n  background: #b72020;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.formButton {\n  width: 100%;\n  padding: 12px;\n  background: #00928F;\n  color: white;\n  border: none;\n  border-Radius: 6px;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n/* ── Tabla ─────────────────────────────────────────────────────── */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.table th {\n  background: #1e6378;\n  color: white;\n  padding: 12px;\n  text-align: left;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.table td {\n  padding: 12px;\n  border-bottom:\n    1px solid #ddd;\n  vertical-align: middle;\n}\n\n/* ── Modal ─────────────────────────────────────────────────────── */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  width: 350px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n/* ── Navbar ────────────────────────────────────────────────────── */\n.navbar {\n  background: #00928F;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.navbar-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px;\n}\n\n.navbar-logo {\n  height: 52px;\n  object-fit: contain;\n}\n\n.navbar-fecha {\n  color: white;\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  font-size: 18 px;\n  opacity: 0.9;\n  text-transform: capitalize;\n}\n\n.navbar-secciones {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 16px;\n  background: rgba(0, 0, 0, 0.15);\n}\n\n/* ── Foto ────────────────────────────────────────────────────── */\n.espacio-foto {\n  width: 120px;\n  height: 120px;\n  border-radius: 6px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px dashed #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  flex-shrink: 0;\n}\n\n/* Sin cursor cuando ya tiene foto */\n.espacio-foto.con-foto {\n  cursor: default;\n  border: 2px solid #ccc;\n}\n\n.table td:first-child {\n  width: 64px;\n  padding: 4px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/*////////////////////////////////////////////////////Responsividad/////////////////////////////////////////////////*/\n/* ── Ajustes generales para el Navbar en Desktop ──────────────── */\n.navbar-hamburger {\n  display: none;\n}\n\n.navbar-links {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.btn-firma {\n  background: #ffc107;\n  color: #000;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.navbar-role {\n  color: white;\n  font-size: 14px;\n}\n\n/* ── Medias Queries ───────────────────────────────────────────── */\n\n/* ─────────────────────────────────────────────────────────────── */\n/* ── Media Queries Unificadas y Optimizadas ──────────────────── */\n/* ─────────────────────────────────────────────────────────────── */\n\n@media (max-width: 768px) {\n\n  /* --- Navbar y Menú Hamburguesa --- */\n  .navbar-top {\n    padding: 10px 16px;\n    position: relative;\n  }\n\n  .navbar-logo {\n    height: 38px;\n  }\n\n  .navbar-fecha {\n    font-size: 11px;\n  }\n\n  .navbar-hamburger {\n    display: block !important;\n    background: transparent;\n    border: none;\n    color: white;\n    font-size: 24px;\n    cursor: pointer;\n    line-height: 1;\n    padding: 4px 8px;\n  }\n\n  .navbar-secciones {\n    display: none;\n    flex-direction: column;\n    width: 100%;\n    padding: 12px 16px;\n    background: #007673;\n    gap: 12px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  /* Estado al desplegar el menú */\n  .navbar-secciones.open {\n    display: flex !important;\n  }\n\n  .navbar-links {\n    flex-direction: column;\n    width: 100%;\n    align-items: stretch;\n    gap: 4px;\n  }\n\n  .tab {\n    width: 100%;\n    text-align: left;\n    padding: 10px 14px;\n    border-bottom: none;\n    border-left: 4px solid transparent;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n\n  /* Visibilidad de pestaña activa en móvil */\n  .tab.active,\n  .navbar-secciones .tab.active {\n    background: rgba(255, 255, 255, 0.2) !important;\n    color: #ffffff !important;\n    border-left: 4px solid #ffffff;\n    border-bottom: none;\n  }\n\n  .navbar-actions {\n    width: 100%;\n    margin-left: 0;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding-top: 10px;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n  }\n\n  .navbar-actions .btn-delete {\n    width: 100%;\n    margin-top: 8px;\n    padding: 10px;\n    font-size: 13px;\n    text-align: center;\n  }\n\n  /* --- Dashboard & Gráficas --- */\n  div[style*=\"gridTemplateColumns: '1fr 1fr'\"],\n  div[style*=\"grid-template-columns: 1fr 1fr\"] {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* --- Modales --- */\n  .modal {\n    width: 92vw !important;\n    max-width: 92vw !important;\n    max-height: 90vh !important;\n    overflow-y: auto;\n    padding: 16px;\n  }\n\n  /* --- Tablas --- */\n  .table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n    width: 100%;\n  }\n\n  .table th,\n  .table td {\n    padding: 10px 8px;\n    font-size: 13px;\n  }\n\n  /* Botones dentro de las celdas de la tabla (Editar / Eliminar) */\n  .table td .btn-edit,\n  .table td .btn-delete,\n  .table td .btn-secondary {\n    width: auto;\n    display: inline-block;\n    padding: 6px 12px;\n  }\n\n  .table td:last-child {\n    white-space: nowrap;\n  }\n\n  /* --- Toolbar de Tablas --- */\n  .table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .btn-search,\n  .table-search-input {\n    width: 100% !important;\n  }\n\n  .table-pagination-info {\n    margin-left: 0;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  /* --- Paginación --- */\n  .table-pagination {\n    flex-wrap: wrap;\n    gap: 4px;\n    justify-content: center;\n  }\n\n  .btn-pag {\n    flex: 0 0 auto;\n    padding: 6px 10px !important;\n  }\n\n  /* --- Vista de Usuarios & Acciones de Secciones --- */\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .section-actions {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n    gap: 0.5rem;\n  }\n\n  .btn-action {\n    width: 100% !important;\n    text-align: center;\n    padding: 8px 6px !important;\n    font-size: 12px !important;\n  }\n\n  .upload-container,\n  .btn-upload {\n    width: 100% !important;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* --- Ajuste de cabecera superior en pantallas pequeñas --- */\n  .navbar-top {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .navbar-logo {\n    order: 1;\n  }\n\n  .navbar-hamburger {\n    order: 2;\n  }\n\n  .navbar-fecha {\n    display: block;\n    width: 100%;\n    order: 3;\n    font-size: 11px;\n    opacity: 0.85;\n  }\n}\n\n@media (max-width: 768px) {\n\n  /* Oculta columnas en móvil */\n  .table th:nth-child(3),\n  /* Usuario */\n  .table td:nth-child(3),\n  .table th:nth-child(4),\n  /* Puesto */\n  .table td:nth-child(4),\n  .table th:nth-child(6),\n  /* Sucursal */\n  .table td:nth-child(6) {\n    display: none;\n  }\n\n  /* Foto más pequeña */\n  .espacio-foto {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  .table td:last-child {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 60px;\n  }\n\n  .btn-edit,\n  .btn-delete,\n  .btn-secondary {\n    width: 100%;\n    text-align: center;\n  }\n  .acciones-celda {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 90px;\n  }\n  .acciones-celda button {\n    width: 100%;\n    font-size: 11px;\n    padding: 5px 6px;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
